import * as React from "react";
import styles from "./index.module.scss";
import Image from "next/image";
import { useEffect, useState, useRef } from "react";
import { useTranslation } from "next-i18next";
import { useWidth } from "@/utils/resize";
import buriedsdk from "@/utils/zz-buried/index";
import { useRouter } from "next/router";

import yes from "@images/pricng/check.png";
import no from "@images/pricng/no.png";
import most from "@images/pricng/most.png";

type Props = {
  cycleUnit: string;
  list: any[];
  isLogin: boolean;
};

const Index = (props: Props) => {
  const { width, display } = useWidth();
  const { t, i18n } = useTranslation("pricing");
  const { cycleUnit, list, isLogin } = props;
  const router = useRouter();
  const { locale } = router;

  const calcPrice = (val: number) => {
    if (props.cycleUnit === "y") return (val / 12).toFixed(0);
    else return val;
  };

  const toCheckout = (name) => {
    buriedsdk.buried({
      event: `按钮点击`,
      scene: `价格页-${name}套餐-Get Started按钮`,
      URL: process.env.publicApiDomain,
    });
  };

  return (
    <div>
      <div className={styles.wrap + " defeaultContainer animate-box"}>
        {list.map((item, index) => (
          <div className={styles.item + " ant"} key={index}>
            {index === 1 && (
              <div className={styles.most}>
                <Image src={most} width={101} height={94}></Image>
              </div>
            )}
            <h3 className={styles.name}>{t(item.comboName)}</h3>
            <div className={styles.price}>
              ${calcPrice(item[`${props.cycleUnit}Price`])}{" "}
              <span>/ {t("Month")}</span>
            </div>
            {props.cycleUnit === "y" && (
              <p className={styles.desc}>{t(item.save)}</p>
            )}
            <p className={styles.desc}>{t(item.desc)}</p>
            <a
              className={styles.started}
              href={isLogin ? "/checkout" : "/login?fromPath=/checkout"}
              onClick={() => toCheckout(item.comboName)}
            >
              {t("Get Started")}
            </a>
            {item.info.map((it, idx) => (
              <div
                className=" w-full flex items-center justify-start mt-[14px]"
                key={idx}
              >
                <div
                  className={
                    (it.status ? "bg-[#68D287]" : "bg-[#FF5F3E]") +
                    " w-[18px] h-[18px] flex justify-center items-center rounded-[50%] mr-[16px]"
                  }
                >
                  <Image
                    src={it.status ? yes : no}
                    width={14}
                    height={14}
                  ></Image>
                </div>
                <div className={styles.tips}>
                  {/* 印尼特殊处理 */}
                  {locale === "id" &&
                  item.comboName === "Professional" &&
                  idx !== 2 ? (
                    <p key={idx}>
                      Akses
                      <span className="mx-[5px] font-[600]">tak terbatas</span>{" "}
                      {idx === 0 ? 'ke daftar':'ke detail'}
                    </p>
                  ) : (
                    <p key={idx}>
                      {it.type && (
                        <span className="mr-[5px] font-[600]">
                          {t(it.hard)}
                        </span>
                      )}
                      {t(it.tips)}
                      {!it.type && (
                        <span className="ml-[5px] font-[600]">
                          {t(it.hard)}
                        </span>
                      )}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
export default Index;
